import { StyledIcon } from '../Icon.Styled'
import type { IconProps } from '../Icon.Types'

export const BodyScanIcon = (props: IconProps) => (
  <StyledIcon
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_84347_20542)">
      <path
        d="M15.9193 9.46443C16.9895 9.46962 17.8571 8.60204 17.8571 7.52665C17.8571 6.45645 16.9895 5.58887 15.9193 5.58887C14.8491 5.58887 13.9815 6.45645 13.9815 7.52665C13.9815 8.59684 14.8491 9.46443 15.9193 9.46443ZM17.8623 9.90082H13.9763C12.5113 9.90082 11.5554 11.1892 11.5554 12.4153V18.3169C11.5554 19.4598 13.1659 19.4598 13.1659 18.3169V12.862H13.4776V27.6993C13.4776 29.2786 15.6596 29.2267 15.7115 27.6993V19.1481H16.1271V27.7045C16.2154 29.3254 18.361 29.1695 18.361 27.6993V12.862H18.6208V18.3169C18.6208 19.4598 20.2832 19.4598 20.2832 18.3169V12.4153C20.2832 11.1944 19.3221 9.90082 17.8623 9.90082Z"
        fill="currentColor"
      />
    </g>
    <g opacity="0.4" clipPath="url(#clip1_84347_20542)">
      <path
        d="M15.9237 8.20661C16.9939 8.21181 17.8615 7.34422 17.8615 6.26883C17.8615 5.19864 16.9939 4.33105 15.9237 4.33105C14.8535 4.33105 13.9859 5.19864 13.9859 6.26883C13.9859 7.33903 14.8535 8.20661 15.9237 8.20661ZM17.8667 8.643H13.9807C12.5157 8.643 11.5598 9.93139 11.5598 11.1574V17.0591C11.5598 18.202 13.1703 18.202 13.1703 17.0591V11.6042H13.482V26.4415C13.482 28.0208 15.664 27.9688 15.7159 26.4415V17.8903H16.1315V26.4467C16.2198 28.0676 18.3654 27.9117 18.3654 26.4415V11.6042H18.6252V17.0591C18.6252 18.202 20.2876 18.202 20.2876 17.0591V11.1574C20.2876 9.93659 19.3265 8.643 17.8667 8.643Z"
        fill="currentColor"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 17C0 16.4477 0.421379 16 0.941176 16H31.0588C31.5786 16 32 16.4477 32 17C32 17.5523 31.5786 18 31.0588 18H0.941176C0.421379 18 0 17.5523 0 17Z"
      fill="currentColor"
    />
    <path
      opacity="0.4"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.19995 2C5.43853 2 3.19995 4.23858 3.19995 7V9.5C3.19995 10.0523 2.75224 10.5 2.19995 10.5C1.64767 10.5 1.19995 10.0523 1.19995 9.5V7C1.19995 3.13401 4.33396 0 8.19995 0H10.7C11.2522 0 11.7 0.447715 11.7 1C11.7 1.55228 11.2522 2 10.7 2H8.19995Z"
      fill="currentColor"
    />
    <path
      opacity="0.4"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.8 2C26.5615 2 28.8 4.23858 28.8 7V9.5C28.8 10.0523 29.2478 10.5 29.8 10.5C30.3523 10.5 30.8 10.0523 30.8 9.5V7C30.8 3.13401 27.666 0 23.8 0H21.3C20.7478 0 20.3 0.447715 20.3 1C20.3 1.55228 20.7478 2 21.3 2H23.8Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.19995 30C5.43853 30 3.19995 27.7614 3.19995 25V17.5C3.19995 16.9477 2.75224 16.5 2.19995 16.5C1.64767 16.5 1.19995 16.9477 1.19995 17.5V25C1.19995 28.866 4.33396 32 8.19995 32H10.7C11.2522 32 11.7 31.5523 11.7 31C11.7 30.4477 11.2522 30 10.7 30H8.19995Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.8 30C26.5615 30 28.8 27.7614 28.8 25V17.5C28.8 16.9477 29.2478 16.5 29.8 16.5C30.3523 16.5 30.8 16.9477 30.8 17.5V25C30.8 28.866 27.666 32 23.8 32H21.3C20.7478 32 20.3 31.5523 20.3 31C20.3 30.4477 20.7478 30 21.3 30H23.8Z"
      fill="currentColor"
    />
    <defs>
      <clipPath id="clip0_84347_20542">
        <rect
          width="9.11466"
          height="12.1529"
          fill="white"
          transform="translate(11.3088 18)"
        />
      </clipPath>
      <clipPath id="clip1_84347_20542">
        <rect
          width="10.6667"
          height="12"
          fill="white"
          transform="translate(10.6499 3.5)"
        />
      </clipPath>
    </defs>
  </StyledIcon>
)
